
export const getSolarPortalApiHeader = () => {
    const token = localStorage.getItem("spToken") as string;
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
    }

    return headers;
}